import React from "react";
import "./HowToPlay.css";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Participants from "../Participants/Participants";
import faq from "../../data/faq";
import Faq from "../Faq/Faq";

const HowToPlay = ({ setIsRegisterPopup }) => {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/how-to-play" && (
        <Helmet>
          <title>
            How to Play the Best Licensed Lottery – New Vikinglotto Guide{" "}
          </title>
          <meta
            name="description"
            content="Learn how to play Vikinglotto – the best licensed European lottery. Discover new draw formats, ticket tips, and safe ways to join from 10 trusted countries."
          />
          <link
            rel="canonical"
            href={`https://lottolegenda.com${location.pathname}`}
          />
        </Helmet>
      )}
      <main className="lottolegenda-main">
        <section className="lottolegenda-how__body pad pad-top flex">
          <div className="lottolegenda-header__demo">
            <h1>How to Play Vikinglotto</h1>
            <button
              className="lottolegenda-header__demo-btn"
              onClick={() => setIsRegisterPopup(true)}
            >
              Try the demo
            </button>
          </div>
          <ul className="lottolegenda-grid-4">
            <li className="lottolegenda-how__list-item">
              <div className="lottolegenda-how__list-img"></div>
              <p className="col-blue t-21 fw-700">1. Pick Your Numbers</p>
              <p>
                Choose 6 main numbers from 1 to 48, and 1 Viking number from 1
                to 5.<br></br>You can select them manually or use the Quick
                Pick option for randomly generated numbers.
              </p>
            </li>
            <li className="lottolegenda-how__list-item">
              <div className="lottolegenda-how__list-img"></div>
              <p className="col-blue t-21 fw-700">2. Buy a Ticket</p>
              <p>
                Purchase your ticket online through official platforms or at
                authorized retailers in participating countries.
              </p>
            </li>
            <li className="lottolegenda-how__list-item">
              <div className="lottolegenda-how__list-img"></div>
              <p className="col-blue t-21 fw-700">3. The Draw Process</p>
              <p>
                Draws are held every Wednesday at 20:00 CET.
                <br></br>All numbers are drawn under strict supervision and in
                accordance with official gaming regulations.
              </p>
            </li>
            <li className="lottolegenda-how__list-item">
              <div className="lottolegenda-how__list-img"></div>
              <p className="col-blue t-21 fw-700">4. Claiming Prizes</p>
              <p>
                If you win, you can claim your prize through the method you
                purchased your ticket:
                <br></br>Online: winnings are paid automatically to your account
                <br></br>In-store: present your winning ticket at a retailer or
                local
              </p>
            </li>
          </ul>
        </section>
        <Participants />
        <section className="pad pad-top flex">
          <h2 className="text-center">Frequently Asked Questions</h2>
          <ul className="lottolegenda-faq__container">
            {faq.map((i) => (
              <Faq id={i.id} item={i} />
            ))}
          </ul>
        </section>
      </main>
    </>
  );
};

export default HowToPlay;
